import { render, staticRenderFns } from "./BankSettings.vue?vue&type=template&id=e92f406e&scoped=true&"
import script from "./BankSettings.vue?vue&type=script&lang=js&"
export * from "./BankSettings.vue?vue&type=script&lang=js&"
import style0 from "./BankSettings.vue?vue&type=style&index=0&id=e92f406e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92f406e",
  null
  
)

export default component.exports